// extracted by mini-css-extract-plugin
export default {"root":"smart-link_root__-1cxH"};